import pdfFile from '../../assets/pdf/handheld.pdf';

function HandheldApp() {
  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src={pdfFile}
        style={{ width: '100%', height: '100%', border: 'none' }}
      ></iframe>
    </div>
  );
}

export default HandheldApp;
